export default function Logo({ className = "h-9" }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/logo-dark.png`}
      alt="Wiese-Fahrzeugpflege Logo"
      className={`${className} w-auto object-contain`}
    />
  );
}
